import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { ReactLenis, useLenis } from "lenis/react";
import { Nav } from "@/components/site/Nav";
import { Footer } from "@/components/site/Footer";
import Landing from "@/pages/Landing";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Contact from "@/pages/Contact";
import Riders from "@/pages/Riders";
import NotFound from "@/pages/NotFound";

const LenisExpose = () => {
  const lenis = useLenis();
  useEffect(() => {
    window.__lenis = lenis;
  }, [lenis]);
  return null;
};

const SiteLayout = () => (
  <>
    <Nav />
    <Outlet />
    <Footer />
  </>
);

function App() {
  const noLenis = typeof window !== "undefined" && window.location.search.includes("nolenis");
  const Router = (
    <BrowserRouter>
      <Routes>
        <Route element={<SiteLayout />}>
          <Route path="/" element={<Landing />} />
          <Route path="/privacy-policy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/riders" element={<Riders />} />
        </Route>
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
  return (
    <div className="App">
      {noLenis ? (
        Router
      ) : (
        <ReactLenis root options={{ lerp: 0.1, smoothWheel: true }}>
          <LenisExpose />
          {Router}
        </ReactLenis>
      )}
    </div>
  );
}

export default App;
